/* unplugin-vue-components disabled */import script from "./CxcyqyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./CxcyqyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./CxcyqyDetail.vue?vue&type=style&index=0&id=6667923e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6667923e"]])

export default __exports__